import { render, staticRenderFns } from "./StockTransferReport.vue?vue&type=template&id=2ab18ecc&"
import script from "./StockTransferReport.vue?vue&type=script&lang=js&"
export * from "./StockTransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab18ecc')) {
      api.createRecord('2ab18ecc', component.options)
    } else {
      api.reload('2ab18ecc', component.options)
    }
    module.hot.accept("./StockTransferReport.vue?vue&type=template&id=2ab18ecc&", function () {
      api.rerender('2ab18ecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/StockTransferReport.vue"
export default component.exports